import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getTechMapWorkTypeAvailableColumns } from './api';

export const path = '/tech-map/work-type/list';

const PageTechMapWorkType: React.FC = (props) => {
  const TechMapWorkType = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getTechMapWorkTypeAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <TechMapWorkType {...props} />;
};

export default PageTechMapWorkType;
